import React, { useRef, useState, useEffect } from "react"
import Image from "../components/image"

export default function Video({
  videoNative,
  posterImage,
  caption,
  person,
  title,
  track
}) {
  const video = useRef()
  const [playing, setPlaying] = useState(false)

  const playVideo = () => {
    setPlaying(true)
  }

  useEffect(() => {
    if (playing) {
      video.current.play()
    }
  }, [playing])

  return (
    <figure className="video">
      <div className="video__media">
        {playing ? (
          <video src={videoNative} preload="none" controls ref={video}>
            {track && <track label="English" kind="subtitles" srclang="en" src={track}></track>}
          </video>
        ) : (
          <button className="video__button" onClick={() => playVideo()}>
            <div className="video__button__inner">
              <svg
                width="9"
                height="11"
                viewBox="0 0 9 11"
                fill="none"
                xmlns="https://www.w3.org/2000/svg"
              >
                <path
                  d="M0 2.05205C0 1.15919 0.982483 0.615173 1.73924 1.08901L7.53532 4.71818C8.24632 5.16336 8.24632 6.19907 7.53532 6.64426L1.73924 10.2734C0.98248 10.7473 0 10.2032 0 9.31038V2.05205Z"
                  fill="white"
                />
              </svg>
              Watch
            </div>
            <Image path={posterImage} className="video__button__image" />
            {/* <div className="video__button__image">
              <img src={posterImage} alt="" width="488" height="270" />
            </div> */}
          </button>
        )}
      </div>
      {caption && (
        <figcaption className="video__caption">
          <p className="video__caption__text">{caption}</p>
          {person && <p className="video__caption__person">{person}</p>}
          {title && <p className="video__caption__title">{title}</p>}
        </figcaption>
      )}
    </figure>
  )
}
